import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import { useRouter } from 'next/router';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { getPosts } from '../../redux/actions/news';
import Head from 'next/head';
import Device from '../Device';
import MetaSeo from '../MetaSeo';
import dynamic from 'next/dynamic';
import useTrans from '../../hooks/useTrans';

export default function detail(props) {
  const trans = useTrans();
  const dispatch = useDispatch();
  const [post_category, setPostCategory] = useState([]);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [share, setShare] = useState();
  const router = useRouter();
  const { news } = useSelector(state => {
    return {
      news: state.news.news,
    };
  }, shallowEqual);
  useEffect(() => {
    if (props.postcategory) {
      getPostCategory();
    }
    setPage(1);
  }, [dispatch, props]);

  useEffect(() => {
    setShare(
      process.env.NEXT_PUBLIC_WEB_URL ||
        window.location.origin + window.location.pathname,
    );
  }, []);
  const getPostCategory = async () => {
    const data = await getPosts(
      { category_id: props.postcategory.id, id: props.id, limit: 3 },
      dispatch,
    );
    if (data) {
      setPostCategory(data.rows);
      setTotal(data.total);
    }
  };
  const loadMore = async () => {
    let new_page = parseInt(page) + 1;
    setPage(new_page);
    const data = await getPosts(
      {
        page: new_page,
        limit: 3,
        category_id: props.postcategory.id,
        id: props.id,
      },
      dispatch,
    );
    if (data) {
      const new_data = [...post_category, ...data.rows];
      setPostCategory(new_data);
    }
  };
  const filterTag = async tag_name => {
    let new_search = `#${tag_name}`;
    setSearch(new_search);
    const data = await getPosts(
      {
        name: new_search,
        page: 1,
        category_id: props.postcategory.id,
        id: props.id,
      },
      dispatch,
    );
    setPage(1);
    setTotal(data.total);
    setPostCategory(data.rows);
  };

  const defaultConfigs = {
    header: {
      textAlign: 'left',
    },
    image: {
      img: {},
      figure: {
        backgroundColor: 'aliceblue',
        border: '1px solid #eee',
      },
      figcaption: {
        borderRadius: '5px',
      },
    },
    video: {
      video: {},
      figure: {
        backgroundColor: 'aliceblue',
        border: '1px solid #eee',
      },
      figcaption: {
        borderRadius: '5px',
      },
    },
    embed: {
      video: {},
      figure: {
        justifyContent: 'center',
      },
      figcaption: {
        borderRadius: '5px',
      },
    },
    paragraph: {
      textAlign: 'left',
      cursor: 'default',
    },
    list: {
      textAlign: 'left',
    },
    checklist: {
      container: {},
      item: {},
      checkbox: {},
      label: {},
    },
    table: {
      table: {},
      tr: {},
      th: {},
      td: {},
    },
    quote: {
      container: {},
      content: {},
      author: {
        fontWeight: 'bold',
      },
      message: {
        textAlign: 'left',
      },
    },
    codeBox: {
      container: {
        width: '100%',
      },
      code: {
        boxSizing: 'border-box',
      },
    },
    warning: {
      container: {
        width: '100%',
      },
      icon: {
        width: '30px',
      },
      title: {
        fontWeight: 500,
      },
      message: {
        fontSize: '14px',
      },
    },
    delimiter: {
      container: {},
      svg: {},
      path: {
        fill: '#231F20',
      },
    },
  };
  const dataSeo = {
    url: `https://tcom.vn/news/${props.seo_url}`,
    type: 'website',
    title: `${props.title} | TCOM`,
    description: props.seo_description || 'TCOM',
    image: props.image,
    domain: 'tcom.vn',
    card: 'summary_large_image',
  };

  const dataSeoEN = {
    url: `https://tcom.vn/en/news/${props.seo_url}`,
    type: 'website',
    title: `${props.title} | TCOM`,
    description: props.seo_description || 'TCOM',
    image: props.image,
    domain: 'tcom.vn',
    card: 'summary_large_image',
  };

  return (
    <>
      {trans.seoVN ? <MetaSeo {...dataSeo} /> : <MetaSeo {...dataSeoEN} />}

      <div id='news-details'>
        <div className='main-content'>
          <div>
            <div className='container'>
              <div className='handleBtnBackNews'>
                <a onClick={() => router.back()}>
                  <svg
                    width='25'
                    height='24'
                    viewBox='0 0 25 24'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M19.5 11.0013H7.64L11.27 6.64125C11.4397 6.43704 11.5214 6.17375 11.497 5.90933C11.4726 5.6449 11.3442 5.40099 11.14 5.23125C10.9358 5.06151 10.6725 4.97985 10.4081 5.00423C10.1437 5.02861 9.89974 5.15704 9.73 5.36125L4.73 11.3613C4.69636 11.409 4.66628 11.4591 4.64 11.5113C4.64 11.5613 4.64 11.5913 4.57 11.6413C4.52467 11.7559 4.50094 11.878 4.5 12.0013C4.50094 12.1245 4.52467 12.2466 4.57 12.3613C4.57 12.4113 4.57 12.4413 4.64 12.4913C4.66628 12.5434 4.69636 12.5935 4.73 12.6413L9.73 18.6413C9.82402 18.7541 9.94176 18.8449 10.0748 18.9071C10.2079 18.9694 10.3531 19.0015 10.5 19.0013C10.7337 19.0017 10.9601 18.9203 11.14 18.7713C11.2413 18.6873 11.325 18.5842 11.3863 18.4679C11.4477 18.3515 11.4855 18.2242 11.4975 18.0932C11.5096 17.9622 11.4957 17.8302 11.4567 17.7046C11.4176 17.579 11.3542 17.4623 11.27 17.3613L7.64 13.0013H19.5C19.7652 13.0013 20.0196 12.8959 20.2071 12.7084C20.3946 12.5208 20.5 12.2665 20.5 12.0013C20.5 11.736 20.3946 11.4817 20.2071 11.2941C20.0196 11.1066 19.7652 11.0013 19.5 11.0013Z'
                      fill='#3E3C3C'
                    />
                  </svg>
                  <span>{trans.seoVN ? 'Quay lại' : 'Back'}</span>
                </a>
              </div>
              <h1 className='page-title'>{props?.title}</h1>
              <div className='meta'>
                <div className='date'>
                  <img
                    src='/assets/images/news-details/icon-calendar.png'
                    alt=''
                  />
                  {moment(props?.show_date || props?.createdAt).format(
                    'DD/MM/YYYY',
                  )}
                </div>
                <div className='share'>
                  <h3>Chia sẻ:</h3>
                  <ul>
                    <li className='facebook'>
                      <a
                        href={`https://www.facebook.com/sharer/sharer.php?u=${share}`}
                        target='_blank'
                      >
                        <svg
                          width={41}
                          height={41}
                          viewBox='0 0 41 41'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <circle
                            cx='20.5'
                            cy='20.9907'
                            r={20}
                            fill='#0381FA'
                          />
                          <path
                            d='M24.8772 13.4696H27.0732V9.64497C26.6943 9.59285 25.3914 9.47559 23.8739 9.47559C20.7078 9.47559 18.5388 11.4671 18.5388 15.1274V18.496H15.0449V22.7717H18.5388V33.5301H22.8225V22.7727H26.1751L26.7073 18.497H22.8215V15.5514C22.8225 14.3156 23.1553 13.4696 24.8772 13.4696Z'
                            fill='white'
                          />
                        </svg>
                      </a>
                    </li>
                    <li className='linkedin'>
                      <a
                        href={`https://www.linkedin.com/sharing/share-offsite/?url=${share}`}
                        target='_blank'
                      >
                        <svg
                          width={41}
                          height={41}
                          viewBox='0 0 41 41'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <g clipPath='url(#clip0_628_2784)'>
                            <path
                              d='M20.4999 0.990723C31.5462 0.990723 40.5 9.94572 40.5 20.9908C40.5 32.0359 31.5462 40.9907 20.4999 40.9907C9.45362 40.9907 0.5 32.0357 0.5 20.9908C0.5 9.94585 9.45376 0.990723 20.4999 0.990723Z'
                              fill='#0077B4'
                            />
                            <path
                              d='M11.77 28.4707H15.5151V15.9881H11.77V28.4707ZM26.3601 15.5558C24.5426 15.5558 22.9163 16.2195 21.7627 17.6846V15.9471H18.0039V28.4708H21.7627V21.6983C21.7627 20.267 23.0739 18.8707 24.7164 18.8707C26.3589 18.8707 26.7639 20.267 26.7639 21.6633V28.4696H30.509V21.3846C30.5088 16.4632 28.1789 15.5558 26.3601 15.5558ZM13.6251 14.7407C14.6601 14.7407 15.5001 13.9007 15.5001 12.8656C15.5001 11.8306 14.6601 10.9907 13.6251 10.9907C12.59 10.9907 11.75 11.8308 11.75 12.8658C11.75 13.9008 12.59 14.7407 13.6251 14.7407Z'
                              fill='white'
                            />
                          </g>
                          <defs>
                            <clipPath id='clip0_628_2784'>
                              <rect
                                width={40}
                                height={40}
                                fill='white'
                                transform='translate(0.5 0.990723)'
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </a>
                    </li>
                    <li className='twitter'>
                      <a
                        href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
                          share,
                        )}`}
                        target='_blank'
                      >
                        <svg
                          width={41}
                          height={41}
                          viewBox='0 0 41 41'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <circle
                            cx='20.5'
                            cy='20.9907'
                            r={20}
                            fill='#02CEFD'
                          />
                          <path
                            d='M34.4401 13.2525C33.4484 13.6875 32.3918 13.9758 31.2901 14.1158C32.4234 13.4392 33.2884 12.3758 33.6951 11.0942C32.6384 11.7242 31.4718 12.1692 30.2284 12.4175C29.2251 11.3492 27.7951 10.6875 26.2351 10.6875C23.2084 10.6875 20.7718 13.1442 20.7718 16.1558C20.7718 16.5892 20.8084 17.0058 20.8984 17.4025C16.3534 17.1808 12.3318 15.0025 9.6301 11.6842C9.15844 12.5025 8.88177 13.4392 8.88177 14.4475C8.88177 16.3408 9.85677 18.0192 11.3101 18.9908C10.4318 18.9742 9.5701 18.7192 8.8401 18.3175C8.8401 18.3342 8.8401 18.3558 8.8401 18.3775C8.8401 21.0342 10.7351 23.2408 13.2201 23.7492C12.7751 23.8708 12.2901 23.9292 11.7868 23.9292C11.4368 23.9292 11.0834 23.9092 10.7518 23.8358C11.4601 26.0008 13.4701 27.5925 15.8601 27.6442C14.0001 29.0992 11.6384 29.9758 9.08177 29.9758C8.63344 29.9758 8.20344 29.9558 7.77344 29.9008C10.1951 31.4625 13.0651 32.3542 16.1601 32.3542C26.2201 32.3542 31.7201 24.0208 31.7201 16.7975C31.7201 16.5558 31.7118 16.3225 31.7001 16.0908C32.7851 15.3208 33.6968 14.3592 34.4401 13.2525Z'
                            fill='white'
                          />
                        </svg>
                      </a>
                    </li>
                    {/* <li className='zalo'>
                                            <a href='true'>
                                                <svg width={41} height={41} viewBox='0 0 41 41' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                                    <circle cx='20.5' cy='20.9907' r={20} fill='#0068FF' />
                                                    <path d='M12.5688 33.2749C12.5848 33.0285 12.5994 32.7807 12.6198 32.5343C12.6752 31.8448 12.732 31.1538 12.7874 30.4643C12.8093 30.1859 12.8253 29.9075 12.8472 29.629C12.8618 29.4439 12.837 29.2937 12.6868 29.1436C12.2626 28.7208 11.8355 28.2952 11.4609 27.8302C10.2495 26.3272 9.47832 24.6158 9.13721 22.7149C8.87044 21.2411 8.96811 19.7819 9.31214 18.3314C9.7378 16.5355 10.5731 14.9524 11.8078 13.5894C12.9828 12.292 14.3603 11.2628 15.9697 10.5485C17.082 10.0558 18.2336 9.71759 19.4406 9.57327C20.7978 9.41292 22.1447 9.44645 23.4932 9.7001C25.4334 10.0645 27.1856 10.8313 28.7498 12.0281C29.7906 12.8241 30.6551 13.7862 31.3898 14.8707C32.1405 15.9801 32.6391 17.1915 32.9467 18.4903C33.1595 19.3927 33.2382 20.3023 33.2251 21.2265C33.2047 22.6172 32.8796 23.9278 32.3198 25.1989C31.8883 26.1771 31.3694 27.094 30.6872 27.9133C29.9874 28.7544 29.1813 29.4818 28.2848 30.1159C26.6361 31.2836 24.7891 31.941 22.8124 32.2442C22.1549 32.3448 21.4771 32.3069 20.8094 32.3346C19.6913 32.3827 18.6286 32.0649 17.5514 31.8463C17.3123 31.7982 17.079 31.7136 16.8502 31.6291C16.5266 31.5095 16.2277 31.546 15.923 31.7005C15.044 32.1451 14.1621 32.5824 13.2787 33.0198C13.0673 33.1247 12.8472 33.2151 12.6329 33.3128C12.611 33.3011 12.5906 33.288 12.5688 33.2749ZM15.7598 18.7003C15.6548 18.8664 15.5819 19.002 15.4915 19.1201C14.544 20.3534 13.5863 21.5793 12.6489 22.8199C12.5265 22.9831 12.4507 23.2076 12.4259 23.4117C12.388 23.7164 12.4769 24.005 12.802 24.1231C13.0105 24.1989 13.2364 24.2689 13.4551 24.2718C14.7379 24.2864 16.0207 24.282 17.3021 24.2805C17.4172 24.2805 17.5353 24.266 17.6476 24.2353C17.9318 24.1581 18.0834 23.9613 18.1038 23.6654C18.133 23.2455 18.0339 23.0021 17.7365 22.8971C17.5382 22.8272 17.3167 22.7936 17.1053 22.7893C16.4172 22.7761 15.7292 22.7849 15.0411 22.7805C14.9289 22.7791 14.8166 22.7499 14.7044 22.7324C14.7583 22.6216 14.7947 22.4977 14.8691 22.4015C15.7146 21.3038 16.5703 20.2119 17.4143 19.1128C17.5907 18.8825 17.7496 18.6347 17.875 18.3737C18.1228 17.8621 17.8808 17.3897 17.3239 17.2877C17.079 17.2425 16.8254 17.2323 16.5761 17.2294C15.9405 17.2221 15.305 17.2221 14.6694 17.2279C14.1854 17.2323 13.7029 17.2454 13.2189 17.26C12.8661 17.2702 12.5688 17.5239 12.544 17.8256C12.5032 18.2994 12.665 18.5443 13.095 18.6303C13.2772 18.6667 13.4653 18.6784 13.6504 18.6799C14.2627 18.6857 14.8749 18.6828 15.4872 18.6842C15.5571 18.6871 15.6257 18.693 15.7598 18.7003ZM22.9407 21.7484C22.9392 21.7484 22.9363 21.7484 22.9348 21.7484C22.9348 21.1726 22.9334 20.5953 22.9348 20.0195C22.9348 19.7498 22.8109 19.553 22.5835 19.4175C22.2818 19.2396 21.9042 19.2906 21.6549 19.5458C21.5689 19.6347 21.4873 19.7207 21.3619 19.6114C20.9537 19.2571 20.4639 19.2192 19.961 19.26C19.4843 19.2979 19.0689 19.4962 18.7394 19.8388C17.6855 20.9306 17.7015 22.8111 18.8867 23.8272C19.4625 24.3214 20.4887 24.4802 21.1258 24.0706C21.4071 23.8884 21.5645 23.8899 21.8313 24.0896C22.2847 24.4292 22.8824 24.1144 22.9319 23.5473C22.9421 23.438 22.9392 23.3257 22.9407 23.2149C22.9407 22.728 22.9407 22.2382 22.9407 21.7484ZM30.0691 21.7586C30.0691 21.6653 30.0764 21.572 30.0676 21.4787C30.0006 20.7848 29.7498 20.1755 29.1798 19.7469C28.0078 18.865 26.2017 19.0924 25.4538 20.4948C25.1856 20.9977 25.1302 21.537 25.1812 22.0895C25.2702 23.0546 25.7643 23.7412 26.6565 24.1231C27.1186 24.3199 27.6142 24.3243 28.1011 24.2514C28.7265 24.1595 29.2411 23.8665 29.6099 23.3374C29.9422 22.8636 30.088 22.3344 30.0691 21.7586ZM23.3197 20.7178H23.3182C23.3182 21.6435 23.3138 22.5706 23.3226 23.4963C23.3241 23.6406 23.3518 23.8082 23.4276 23.9248C23.5952 24.18 23.9902 24.2791 24.2949 24.1843C24.5981 24.0896 24.7643 23.8636 24.7876 23.5152C24.792 23.4569 24.7935 23.3986 24.7935 23.3403C24.792 21.5108 24.7906 19.6813 24.7862 17.8533C24.7862 17.779 24.7774 17.6988 24.7468 17.6332C24.6185 17.3475 24.1987 17.1682 23.8459 17.241C23.5223 17.3081 23.3197 17.5647 23.3197 17.9218C23.3182 18.8533 23.3197 19.7863 23.3197 20.7178Z' fill='white' />
                                                    <path d='M15.761 18.7002C15.6269 18.6929 15.5584 18.6871 15.4899 18.6871C14.8776 18.6856 14.2654 18.6885 13.6531 18.6827C13.468 18.6812 13.2785 18.6681 13.0977 18.6331C12.6662 18.5486 12.5059 18.3037 12.5467 17.8284C12.5729 17.5267 12.8689 17.273 13.2216 17.2628C13.7056 17.2483 14.1881 17.2351 14.6721 17.2308C15.3077 17.2249 15.9433 17.2249 16.5788 17.2322C16.8281 17.2351 17.0818 17.2453 17.3267 17.2905C17.8821 17.3926 18.1241 17.8649 17.8777 18.3766C17.7523 18.636 17.5934 18.8853 17.417 19.1156C16.5745 20.2162 15.7188 21.3066 14.8718 22.4043C14.7975 22.5005 14.761 22.6245 14.7071 22.7352C14.8193 22.7527 14.9316 22.7819 15.0438 22.7833C15.7319 22.7892 16.4199 22.779 17.108 22.7921C17.3194 22.7965 17.541 22.83 17.7392 22.9C18.0366 23.0049 18.1357 23.2484 18.1066 23.6682C18.0862 23.9641 17.9345 24.1609 17.6503 24.2382C17.5395 24.2688 17.42 24.2819 17.3048 24.2834C16.022 24.2848 14.7392 24.2892 13.4578 24.2746C13.2391 24.2717 13.0132 24.2017 12.8047 24.1259C12.4782 24.0079 12.3893 23.7178 12.4286 23.4146C12.4549 23.209 12.5292 22.9845 12.6517 22.8227C13.5904 21.5822 14.5467 20.3562 15.4943 19.1229C15.5832 19.0019 15.6561 18.8664 15.761 18.7002Z' fill='#0068FF' />
                                                    <path d='M22.9411 21.7437C22.9411 22.2335 22.9411 22.7219 22.9411 23.2117C22.9411 23.3225 22.9425 23.4333 22.9323 23.544C22.8828 24.1111 22.2836 24.426 21.8317 24.0863C21.5649 23.8866 21.4075 23.8852 21.1262 24.0674C20.4891 24.4785 19.4629 24.3181 18.8871 23.8239C17.7019 22.8064 17.6859 20.9274 18.7398 19.8355C19.0707 19.493 19.4847 19.2947 19.9614 19.2568C20.4643 19.216 20.9541 19.2539 21.3623 19.6081C21.4877 19.7174 21.5693 19.63 21.6553 19.5425C21.9031 19.2874 22.2822 19.2364 22.5839 19.4142C22.8128 19.5498 22.9367 19.7466 22.9352 20.0163C22.9338 20.5921 22.9352 21.1694 22.9352 21.7452C22.9367 21.7437 22.9381 21.7437 22.9411 21.7437ZM21.441 21.7772C21.4527 21.4551 21.355 21.1679 21.1495 20.9215C20.7107 20.3953 19.9235 20.4842 19.6276 21.0994C19.4162 21.5382 19.4075 21.9915 19.6174 22.4318C19.7777 22.7685 20.081 22.9216 20.4366 22.9435C20.7501 22.9624 21.0227 22.8443 21.1976 22.5674C21.3477 22.3254 21.4542 22.0688 21.441 21.7772Z' fill='#0068FF' />
                                                    <path d='M30.071 21.7567C30.0899 22.3325 29.9441 22.8602 29.6118 23.3369C29.243 23.8646 28.7284 24.1576 28.103 24.2509C27.6146 24.3223 27.1205 24.3194 26.6584 24.1226C25.7648 23.7421 25.2706 23.0541 25.1831 22.089C25.1321 21.5365 25.1875 20.9972 25.4557 20.4942C26.2035 19.0919 28.0097 18.8645 29.1817 19.7464C29.7517 20.1765 30.0024 20.7843 30.0695 21.4782C30.0783 21.5701 30.071 21.6634 30.071 21.7567ZM26.6409 21.7625C26.6379 22.1736 26.7575 22.4957 27.0447 22.745C27.4718 23.1153 28.1963 23.006 28.4266 22.5059C28.6438 22.0351 28.6759 21.5395 28.4266 21.0584C28.2619 20.7406 27.9849 20.5861 27.6307 20.5803C27.2823 20.5759 27.0141 20.7319 26.8347 21.0307C26.6948 21.2669 26.6365 21.5249 26.6409 21.7625Z' fill='#0068FF' />
                                                    <path d='M23.3214 20.7147C23.3214 19.7832 23.3199 18.8502 23.3229 17.9187C23.3243 17.5616 23.5269 17.305 23.8491 17.2379C24.2004 17.1651 24.6203 17.3444 24.75 17.6301C24.7792 17.6957 24.7894 17.7759 24.7894 17.8502C24.7937 19.6797 24.7952 21.5092 24.7967 23.3372C24.7967 23.3955 24.7952 23.4538 24.7908 23.5121C24.7675 23.862 24.5999 24.0865 24.2981 24.1812C23.9934 24.276 23.5984 24.1754 23.4307 23.9217C23.3535 23.8051 23.3272 23.6375 23.3258 23.4932C23.317 22.5675 23.3214 21.6404 23.3214 20.7147C23.3199 20.7147 23.3199 20.7147 23.3214 20.7147Z' fill='#0068FF' />
                                                    <path d='M21.4434 21.7791C21.4565 22.0707 21.3501 22.3273 21.2 22.5678C21.025 22.8462 20.7524 22.9628 20.439 22.9439C20.0833 22.922 19.7801 22.769 19.6198 22.4322C19.4098 21.992 19.4186 21.5386 19.63 21.0998C19.9259 20.4861 20.7131 20.3972 21.1519 20.922C21.3574 21.1713 21.4536 21.4584 21.4434 21.7791Z' fill='white' />
                                                    <path d='M26.6389 21.7605C26.6345 21.5228 26.6928 21.2648 26.8342 21.0287C27.0135 20.7298 27.2803 20.5738 27.6302 20.5782C27.9844 20.5826 28.2614 20.7371 28.4261 21.0564C28.6754 21.536 28.6433 22.0331 28.4261 22.5039C28.1958 23.0039 27.4713 23.1132 27.0442 22.743C26.7541 22.4937 26.6345 22.1715 26.6389 21.7605Z' fill='white' />
                                                </svg>
                                            </a>
                                        </li> */}
                  </ul>
                </div>
              </div>
              <div className='post'>
                <div dangerouslySetInnerHTML={{ __html: props.html_content }} />
                <div className='author'>Biên tâp: TCOM</div>
              </div>
            </div>
            <div className='r-news-list'>
              <div className='container'>
                {post_category
                  ? post_category.map((item, index) => (
                      <div className='news-item'>
                        <div className='row'>
                          <div className='col-12 col-md-5'>
                            <Link
                              href={`/news/${item.seo_url}`}
                              className='image d-block'
                            >
                              <img
                                className='img-new'
                                src={item.image}
                                style={{
                                  maxHeight: 263,
                                  borderRadius: 15,
                                  width: 454,
                                  maxWidth: '100%',
                                  objectFit: 'cover',
                                  aspectRatio: '16/9',
                                }}
                                alt=''
                              />
                            </Link>
                          </div>
                          <div className='col-12 col-md-7'>
                            <div className='content'>
                              <a href className='category'>
                                {item?.postcategory?.name}
                              </a>
                              <Link href={`/news/${item.seo_url}`}>
                                <a className='title'>{item?.title}</a>
                              </Link>
                              <div className='date'>
                                {moment(
                                  item?.show_date || item?.createdAt,
                                ).format('DD/MM/YYYY')}
                              </div>
                              <p className='content-news'>
                                {item.html_content}
                              </p>
                              {/* <p className='desc'>{item.seo_description}</p> */}
                              <ul className='tag'>
                                {item.tag
                                  ? item.tag?.map((tag, index) => {
                                      return (
                                        <li key={index}>
                                          <a
                                            onClick={() =>
                                              filterTag(tag.tag.name)
                                            }
                                          >
                                            {tag.tag.name}
                                          </a>
                                        </li>
                                      );
                                    })
                                  : null}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  : null}
                {post_category.length < total ? (
                  <div className='text-center'>
                    <a onClick={() => loadMore()} className='see-more'>
                      XEM THÊM
                    </a>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
